const { v4: uuid } = require('uuid');

const constants = require('../constants');
const { getConsentDateInLocalTimeFormatWithTimeZone } = require('./dateTimeUtils');

const { CONSENT_STATUS } = constants;

const DEFAULT_UI_VERSION = '001';

function generateDeviceIdentifier() {
  const newIdentifier = uuid();
  return newIdentifier;
}

/**
 * Function to generate consent request body
 * @param {object[]} templates Templates array received from GET templates request
 * @param {string[]} selectedConsents Array of consent template IDs accepted by the user
 * @param {string} [version] Functional UI version in the format XXX (Eg. 001, 023)
 * @returns {object} Consent object that can be attached body of any call that needs consents
 */
function getConsentBody(templates, selectedConsents, version = DEFAULT_UI_VERSION) {
  const currentDate = new Date();

  const composedTemplate = templates.find((template) => !template.templateAtomic);
  const atomicTemplates = templates.filter((template) => template.templateAtomic);

  const composedTemplateStatus = {
    consentTemplateId: composedTemplate.templateId,
    consentStatusId: CONSENT_STATUS.ACCEPTED,
  };

  const relatedConsents = atomicTemplates.map((template) => ({
    consentTemplateId: template.templateId,
    consentStatusId: selectedConsents.includes(template.templateId)
      ? CONSENT_STATUS.ACCEPTED
      : CONSENT_STATUS.NOT_ACCEPTED,
    templateCategoryType: template.templateCategoryType,
  }));

  const context = {
    dateTimeChannel: currentDate.toISOString(),
  };

  const evidence = {
    deviceIdentifier: generateDeviceIdentifier(),
    version,
  };

  const consentDate = getConsentDateInLocalTimeFormatWithTimeZone();

  return {
    ...composedTemplateStatus,
    relatedConsents,
    context,
    evidence,
    consentDate,
  };
}

module.exports = {
  getConsentBody,
  generateDeviceIdentifier,
};
